import { User, Boxes, Gamepad2, Network, Building2, Drama, LucideIcon } from 'lucide-react';
import { EntityType } from '@/types/tags';

// Entity type display configuration with modern icons (no emojis!)
export const ENTITY_CONFIG: Record<EntityType, {
  icon: LucideIcon;
  label: string;
  singularLabel: string;
  color: string;
  bgColor: string;
  borderColor: string;
  description: string;
}> = {
  [EntityType.PERSON]: {
    icon: User,
    label: 'People',
    singularLabel: 'Person',
    color: 'text-purple-600 dark:text-purple-400',
    bgColor: 'bg-purple-100 dark:bg-purple-500/20',
    borderColor: 'border-purple-300 dark:border-purple-500',
    description: 'Key figures and thought leaders in crypto'
  },
  [EntityType.PROJECT]: {
    icon: Boxes,
    label: 'Projects',
    singularLabel: 'Project',
    color: 'text-blue-600 dark:text-blue-400',
    bgColor: 'bg-blue-100 dark:bg-blue-500/20',
    borderColor: 'border-blue-300 dark:border-blue-500',
    description: 'Notable blockchain projects and initiatives'
  },
  [EntityType.GAME]: {
    icon: Gamepad2,
    label: 'Games',
    singularLabel: 'Game',
    color: 'text-green-600 dark:text-green-400',
    bgColor: 'bg-green-100 dark:bg-green-500/20',
    borderColor: 'border-green-300 dark:border-green-500',
    description: 'Web3 games and gaming platforms'
  },
  [EntityType.CHARACTER]: {
    icon: Drama,
    label: 'Characters',
    singularLabel: 'Character',
    color: 'text-pink-600 dark:text-pink-400',
    bgColor: 'bg-pink-100 dark:bg-pink-500/20',
    borderColor: 'border-pink-300 dark:border-pink-500',
    description: 'Mascots and IP figures (usually token- or NFT-backed)'
  },
  [EntityType.PROTOCOL]: {
    icon: Network,
    label: 'Protocols',
    singularLabel: 'Protocol',
    color: 'text-orange-600 dark:text-orange-400',
    bgColor: 'bg-orange-100 dark:bg-orange-500/20',
    borderColor: 'border-orange-300 dark:border-orange-500',
    description: 'DeFi protocols and blockchain infrastructure'
  },
  [EntityType.ORGANIZATION]: {
    icon: Building2,
    label: 'Organizations',
    singularLabel: 'Organization',
    color: 'text-cyan-600 dark:text-cyan-400',
    bgColor: 'bg-cyan-100 dark:bg-cyan-500/20',
    borderColor: 'border-cyan-300 dark:border-cyan-500',
    description: 'Companies, DAOs, and crypto organizations'
  }
};

export const ENTITY_TYPE_ORDER = [
  EntityType.GAME,
  EntityType.PERSON,
  EntityType.PROJECT,
  EntityType.CHARACTER,
  EntityType.ORGANIZATION,
  EntityType.PROTOCOL
];

// Helper to get entity icon component
export const getEntityIcon = (entityType: EntityType): LucideIcon => {
  return ENTITY_CONFIG[entityType]?.icon ?? Boxes;
};

// Helper to get entity label (singular)
export const getEntityLabel = (entityType: EntityType): string => {
  return ENTITY_CONFIG[entityType]?.singularLabel ?? 'Entity';
};

